import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Holds a getToken function provided by <AuthTokenInjector/>. Any API call
// made before we have it goes without a token and will 401 (expected).
let getTokenFn = null;
export const setAuthTokenGetter = (fn) => {
  getTokenFn = fn;
};

const authHeaders = async () => {
  if (!getTokenFn) return {};
  try {
    const token = await getTokenFn();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
};

export const listSchedules = async () => {
  const headers = await authHeaders();
  const { data } = await axios.get(`${API}/schedules`, { headers });
  return data;
};

export const createSchedule = async (payload) => {
  const headers = await authHeaders();
  const { data } = await axios.post(`${API}/schedules`, payload, { headers });
  return data;
};

export const updateSchedule = async (id, payload) => {
  const headers = await authHeaders();
  const { data } = await axios.patch(`${API}/schedules/${id}`, payload, { headers });
  return data;
};

export const deleteSchedule = async (id) => {
  const headers = await authHeaders();
  const { data } = await axios.delete(`${API}/schedules/${id}`, { headers });
  return data;
};

// -------- Templates --------
export const listTemplates = async () => {
  const headers = await authHeaders();
  const { data } = await axios.get(`${API}/templates`, { headers });
  return data;
};

export const createTemplate = async (payload) => {
  const headers = await authHeaders();
  const { data } = await axios.post(`${API}/templates`, payload, { headers });
  return data;
};

export const deleteTemplate = async (id) => {
  const headers = await authHeaders();
  const { data } = await axios.delete(`${API}/templates/${id}`, { headers });
  return data;
};

// -------- Preferences (quiet hours) --------
export const getPreferences = async () => {
  const headers = await authHeaders();
  const { data } = await axios.get(`${API}/preferences`, { headers });
  return data;
};

export const updatePreferences = async (payload) => {
  const headers = await authHeaders();
  const { data } = await axios.patch(`${API}/preferences`, payload, { headers });
  return data;
};

// -------- Calendar sync --------
export const syncCalendar = async () => {
  const headers = await authHeaders();
  const { data } = await axios.post(`${API}/calendar/sync`, {}, { headers });
  return data;
};

export const disconnectCalendar = async () => {
  const headers = await authHeaders();
  const { data } = await axios.delete(`${API}/calendar/disconnect`, { headers });
  return data;
};
